
import {defineComponent, Ref, ref} from "vue";
import {useStore} from "vuex";
import {dispatchErrorBox} from "../../mixins";
import {RepositoryException} from "../../../../../domain/exceptions/exceptions";

export default defineComponent({
  name: "modalAlert",

  setup() {
    const store = useStore();

    /** Variable that controls the opening and closing of the modal. */
    const modalAlertOpened: Ref<boolean> = ref(true);

    /** Function triggered when the modal closes.
     * When the modal is closed, all products are removed from the cart and the order id is removed from the route. */
    async function close() {
      try {
        await store.dispatch("shop_module/removeAllProductsFromBag");
        modalAlertOpened.value = !modalAlertOpened.value;
      } catch (e) {
        if (e instanceof RepositoryException) {
          await dispatchErrorBox(e.message);
        } else {
          console.error(e);
          await dispatchErrorBox("Ocorreu um erro inesperado.");
        }
      }
    }

    return {
      modalAlertOpened,
      close
    };
  }
});
